import type { Panorama } from "@/store/editorStore";

export type PanoramaMediaType = "panorama" | "zoomable_image";

export const getPanoramaMediaType = (panorama?: Panorama | null): PanoramaMediaType => {
  const data = (panorama?.data as { media_type?: string } | undefined) ?? undefined;
  return data?.media_type === "zoomable_image" ? "zoomable_image" : "panorama";
};

export const setPanoramaMediaType = (
  data: Record<string, unknown> | null | undefined,
  mediaType: PanoramaMediaType,
): Record<string, unknown> => ({
  ...(data ?? {}),
  media_type: mediaType,
});
